export default function ContactSection() {
  return (
    <section id="contact" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-8 md:mb-10">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
              联系我们
            </h2>
            <p className="mt-2 text-sm md:text-base text-foreground-600">
              欢迎投递大赛吃瓜线索，每日大赛黑料期待你的爆料
            </p>
          </div>

          <div className="bg-background-100 rounded-2xl p-8 md:p-10 border border-background-200/60">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8 text-center">
              <div className="p-4">
                <div className="w-12 h-12 rounded-full bg-primary-100 flex items-center justify-center mx-auto mb-3">
                  <i className="ri-mail-line text-primary-600 text-xl"></i>
                </div>
                <h3 className="text-sm font-semibold text-foreground-900 mb-1">爆料投稿</h3>
                <p className="text-xs text-foreground-500">tips@dasaicheliao.com</p>
              </div>
              <div className="p-4">
                <div className="w-12 h-12 rounded-full bg-accent-100 flex items-center justify-center mx-auto mb-3">
                  <i className="ri-wechat-line text-accent-600 text-xl"></i>
                </div>
                <h3 className="text-sm font-semibold text-foreground-900 mb-1">微信客服</h3>
                <p className="text-xs text-foreground-500">dasaicheliao_kf</p>
              </div>
              <div className="p-4">
                <div className="w-12 h-12 rounded-full bg-secondary-100 flex items-center justify-center mx-auto mb-3">
                  <i className="ri-chat-smile-2-line text-secondary-600 text-xl"></i>
                </div>
                <h3 className="text-sm font-semibold text-foreground-900 mb-1">商务合作</h3>
                <p className="text-xs text-foreground-500">bd@dasaicheliao.com</p>
              </div>
            </div>
            <p className="mt-6 text-xs text-foreground-500 text-center">
              投稿请确保内容真实可查，每日大赛黑料将对爆料人信息严格保密
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}